import classNames from 'classnames';
import { mergeStyles, sizeClassName as sizeClassNameFromCommon, } from 'wix-rich-content-common';
import viewerStyles from './styles/video-viewer.scss';
export var containerClassName = function (theme) {
    if (theme === void 0) { theme = {}; }
    var mergedStyles = mergeStyles({ styles: viewerStyles, theme: theme });
    return mergedStyles.video_container;
};
export var sizeClassName = function (componentData, theme, styles, isMobile) {
    var className = sizeClassNameFromCommon(componentData, theme, styles, isMobile, '');
    return classNames(className, theme['videoPlugin']);
};
//# sourceMappingURL=classNameStrategies.js.map